module.exports = __webpack_public_path__ + "img/141ne.67b9855a.svg";